export enum CopyConfigStatus {
  NoChanges,
  NewChanges
}
